import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classNames from "classnames";
import PropTypes from "prop-types";

import Label from "components/library/Label";
import Button from "components/library/Button";
import IconButton from "components/library/IconButton";
import { saveForm } from "editor/actions/status";
import { updateFormAt, updateEditor } from "editor/actions/form";

import styles from "./SocialImage.css";

class SocialImage extends Component {
  constructor(props) {
    super(props);

    this.activateImageEditor = this._activateImageEditor.bind(this);
    this.removeSocialImage = this._removeSocialImage.bind(this);
  }

  _activateImageEditor() {
    return this.props.saveForm().then(() => {
      this.props.history.replace(`${this.props.getBaseUrl()}social-seo`); // add ID if article hasn't been saved yet
      this.props.history.push(`${this.props.getBaseUrl()}social-image`);
    });
  }

  _removeSocialImage() {
    this.props.updateFormAt("social_image", null);
  }

  render() {
    const hasImage =
      this.props.socialImage &&
      Object.keys(this.props.socialImage) &&
      "crops" in this.props.socialImage;

    let button = null;
    if (!hasImage) {
      button = (
        <Button
          className={this.props.className}
          role="link"
          onClick={this.activateImageEditor}
          type="secondary"
          isDisabled={this.props.disabled}
        >
          Add a custom social image
        </Button>
      );
    }

    return (
      <div
        className={classNames(
          styles.root,
          hasImage ? styles.hasImage : styles.noImage
        )}
      >
        {button}
        {hasImage ? (
          <figure className={styles.figure}>
            <Label>Social image</Label>
            <div className={styles.placeholder}>
              <div className={styles.imageWrapper}>
                <img src={this.props.socialImage.crops["16x9"].url} />
              </div>
              {!this.props.disabled && (
                <IconButton
                  className={styles.icon}
                  name="x"
                  onClick={this.removeSocialImage}
                />
              )}
            </div>
          </figure>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    socialImage: state.editor.form.social_image,
    id: state.editor.form.id,
    status: state.editor.status,
  };
};

const mapDispatchToProps = {
  saveForm,
  updateFormAt,
  updateEditor,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SocialImage)
);

SocialImage.propTypes = {
  className: PropTypes.string,
  getBaseUrl: PropTypes.func.isRequired,
  history: PropTypes.object,
  match: PropTypes.object,
  status: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  socialImage: PropTypes.object,
};
